const esploraBaseUrl = 'https://btc.atomic.loans/api/';
const esploraAltBaseUrl = 'https://blockstream.info/api';

export default {
  bitcoin: {
    api: `${esploraBaseUrl}`,
    altApi: `${esploraAltBaseUrl}`,
    batchApi: 'https://atomic.finance/electrs-batch',
    network: 'bitcoin',
    value: 1000000,
    mineBlocks: true,
    explorer: `https://blockstream.info/tx`,
  },
  basename: '/odds/app',
  oracle: {
    url: 'https://oracle.atomic.finance',
  },
  tower: {
    url: 'https://tower.atomic.finance',
  },
  broker: {
    url: 'wss://broker.atomic.finance/',
  },
  pay: {
    url: 'https://atomic.finance/pay',
  },
  mailchimp: {
    url: 'https://atomic.finance/mailchimp'
  },
  fee: '0.05',
};
